import type { FC } from 'react';

import ProjectNavigation from './ProjectNavigation';
import useProjectNavigation from './selectors';

interface ProjectNavigationContainerProps {
    activeItem: string;
}

const ProjectNavigationContainer: FC<ProjectNavigationContainerProps> = ({ activeItem }) => {
    const navigation = useProjectNavigation();

    return <ProjectNavigation navigation={navigation} activeItem={activeItem} />;
};

export default ProjectNavigationContainer;
